
const ipaConfig = {
  appName: "",
  configUserType: "dev-mgr-access",
  scriptPlugins: [],
  redux: {
    slices: []
  },
  components: {
    dashboard: [],
    entityData: [],
    entityAction: []
  }
}

export default ipaConfig